import { render, staticRenderFns } from "./edit-itinerary.vue?vue&type=template&id=738d69ce&"
import script from "./edit-itinerary.vue?vue&type=script&lang=js&"
export * from "./edit-itinerary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports